/********************************************
 * HEADER MENU
 ********************************************/
function menuOpen() {
	$('.menu-hamburger').on('click', function () {
		$('body').toggleClass('is-open-menu');
		$('.menu-main').slideToggle();
	});
}
